import {useQueryChancePage} from "@/service/chance.s";
import React, {FC} from "react";
import {ProTable} from "@/widget/ProTable/ProTable";
import {GridColDef} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import {checkQueryKey, formatTime} from "@/helper/method";
import {ChancePO} from "@/model/customer";
import {ProgressBar} from "@/widget/ProgressBar/ProgressBar";
import {Typography} from "@mui/material";

export interface ChanceTableProps {
    customerId?: number;
    contractId?: number;
}

export const ChanceTable: FC<ChanceTableProps> = ({customerId, contractId}) => {
    const {
        mutate: chancePageMutate,
        data: chancePageData,
        isPending: chancePagePending,
    } = useQueryChancePage()

    const chanceColumns: GridColDef<ChancePO>[] = [
        {field: "category", headerName: "商机名称", flex: 0.6,},
        {field: "stage", headerName: "商机阶段", flex: 0.4,},
        {
            field: "contractId",
            headerName: "是否转化",
            width: 80,
            display: 'flex',
            renderCell: ({row: {contractId}}) => {
                return checkQueryKey(contractId) ? <Typography color={'success'}>已转化</Typography> : <Typography color={'warning'}>未转化</Typography>
            }
        },
        {
            field: "money",
            headerName: "商机金额",
            flex: 0.4,
            renderCell: ({row}) => <Box color={'red'} component={'span'}>{`￥${row.money}`}</Box>
        },
        {field: "dealRate", headerName: "成交概率", flex: 0.4, headerAlign: 'center', valueGetter: (value, row) => row.dealRate, type: 'number', renderCell: ProgressBar},
        {field: "dealDate", headerName: "预计成交时间", flex: 0.5, valueFormatter: (_, row) => formatTime("D", row.dealDate)},

    ];

    return <ProTable<ChancePO> columnHeaderHeight={40} autoHeight={false} loading={chancePagePending} checkboxSelection={false}
                               onSearch={(params) => chancePageMutate({...params, customerId, contractId})}
                               data={chancePageData?.data} pageSize={5} showToolbar={false}
                               columns={chanceColumns}/>
}